/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal referential DTO for Priority, Status
 * @export
 * @interface ReferentielMinimalDto
 */
export interface ReferentielMinimalDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof ReferentielMinimalDto
     */
    id?: string;
    /**
     * Code of the referential
     * @type {string}
     * @memberof ReferentielMinimalDto
     */
    code?: string;
    /**
     * Display label
     * @type {string}
     * @memberof ReferentielMinimalDto
     */
    label?: string;
    /**
     * Color code (hex format)
     * @type {string}
     * @memberof ReferentielMinimalDto
     */
    color?: string;
}

/**
 * Check if a given object implements the ReferentielMinimalDto interface.
 */
export function instanceOfReferentielMinimalDto(value: object): value is ReferentielMinimalDto {
    return true;
}

export function ReferentielMinimalDtoFromJSON(json: any): ReferentielMinimalDto {
    return ReferentielMinimalDtoFromJSONTyped(json, false);
}

export function ReferentielMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentielMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function ReferentielMinimalDtoToJSON(json: any): ReferentielMinimalDto {
    return ReferentielMinimalDtoToJSONTyped(json, false);
}

export function ReferentielMinimalDtoToJSONTyped(value?: ReferentielMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'color': value['color'],
    };
}

